// while this regex is *very* basic and doesn't comprehensively match guids it is sufficient
// for differentiating between a 'guid-like' id and any other similarly nested path
var guidRegex = '[0-9A-Fa-f\\-]{36}';
export var routeForDashboard = '/';
export var routeForMedicationLists = '/medications-list';
export var routeForNewMedicationList = '/medications-list/new';
export var routeForMedicationList = "/medications-list/:medListId(" + guidRegex + ")";
export var createRouteForMedicationList = function (medListId) { return "/medications-list/" + medListId; };
export var routeForDetailsMatch = function (root) { return root + "/:medicationId"; };
export var routeForPharmacyRequest = function (root) { return root + "/new"; };
export var routeForSummary = function (root) { return root; };
export var routeForDetails = function (root, medicationId) { return root + "/" + medicationId; };
